"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Texts_1 = require("../Texts");
const StyledComponents_1 = require("./StyledComponents");
const defaultProps = {};
const TextAreaInput = ({ prependElements, appendElements, children: _, error, hint, label, small, large, ...inputProps }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(StyledComponents_1.Container, null,
        label && react_1.default.createElement(Texts_1.LabelText, null, label),
        react_1.default.createElement(StyledComponents_1.InputContainer, { error: error ? true : false, small: small, large: large },
            prependElements,
            react_1.default.createElement(StyledComponents_1.TextArea, { ...inputProps }),
            appendElements)),
    react_1.default.createElement(Texts_1.HintText, { error: !!error },
        error || hint,
        "\u00A0")));
TextAreaInput.defaultProps = defaultProps;
exports.default = react_1.default.memo(TextAreaInput);
